import React, { useContext } from "react";
import { Box, ListItem, ListItemText } from "@mui/material";
import { getColors } from "../../themes/theme";
import { useNavigate, useParams } from "react-router-dom";
import { ThemeContext } from "../../context/ThemeContext";
import { useProtocolData } from "../../hooks/protocoldata/useProtocolData";
import { useAuthContext } from "../../hooks/contexts/useAuthContext";
import { isEmpty } from "../../utils/isEmpty";
import useMediaQuery from "@mui/material/useMediaQuery";

export const SubList = ({ data }) => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const { mainId, subId } = useParams();
  const navigate = useNavigate();
  const { darkMode } = useContext(ThemeContext);
  const { token } = useAuthContext();
  const { conditions } = useProtocolData(token);

  const handleSubItemClick = (subId) => {
    navigate(`/exercise/${mainId}/${subId}`, {
      state: {
        exerciseData: data,
      },
    });
  };

  const selectedSubItems = isEmpty(data[mainId])
    ? conditions[mainId] ?? []
    : data[mainId];

  return (
    <Box
      sx={{
        display: isMobile ? "none" : "block",
        height: "100%",
        width: { xs: "220px", lg: "300px" },
        minWidth: { xs: "220px", lg: "300px" },
        px: { xs: "10px", lg: "20px" },
        pt: 2,
        borderRight: `1px solid ${
          darkMode ? getColors.appBarBorderDark : getColors.appBarBorderLight
        }`,
      }}
    >
      {selectedSubItems.map((subItem, index) => (
        <ListItem
          key={index}
          onClick={() => handleSubItemClick(subItem)}
          sx={{
            fontSize: { xs: "20px", lg: "22px" },
            px: { xs: "20px", lg: "28px" },
            py: { xs: "10px", lg: "14px" },
            mb: 1,
            background:
              subId === subItem ? getColors.listItemHoverBg : "transparent",
          }}
        >
          <ListItemText
            primary={subItem}
            sx={{
              "& .MuiListItemText-primary": {
                color: subId === subItem && getColors.primaryTextDark,
              },
            }}
          />
        </ListItem>
      ))}
    </Box>
  );
};
